import { render } from "./LosantForm.vue?vue&type=template&id=0d31cb81&ts=true"
import script from "./LosantForm.vue?vue&type=script&lang=ts"
export * from "./LosantForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__